import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import {
  HELP_SECTION_REQUEST_CODES,
  HELP_TOPIC_REQUEST_CODES,
  HELP_TOPIC_APPLY_CODES_SIGN_IN,
  HELP_TOPIC_APPLY_CODES_REGISTER,
  HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES,
  HELP_TOPIC_APPLY_CODES_REQUEST_CODES,
} from '@app/constants';

const RequestCodesSection = ({ activeTopic, scrollToTopic }) => {
  useEffect(() => {
    activeTopic && scrollToTopic(activeTopic);
  }, [activeTopic, scrollToTopic]);

  return (
    <div id={HELP_SECTION_REQUEST_CODES} className="help-section">
      <div id={HELP_TOPIC_REQUEST_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-request-codes" tagName="h2" />
        <LocalizedText id="qau-help-topic-request-codes-p1" tagName="p" />
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_SIGN_IN} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-sign-in" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-sign-in-p1" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_REGISTER} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-register" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-register-p1" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-authorize-codes" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-authorize-codes-p1" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-authorize-codes-p2" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-authorize-codes-p3" tagName="p" />
        </div>
      </div>
      <div id={HELP_TOPIC_APPLY_CODES_REQUEST_CODES} className="section-topic">
        <LocalizedText id="qau-help-topic-apply-codes-request-codes" tagName="h3" />
        <div>
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p1" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p2" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p3" tagName="p" />
          <LocalizedText id="qau-help-topic-apply-codes-request-codes-p4" tagName="p" />
        </div>
      </div>
    </div>
  );
};

RequestCodesSection.propTypes = {
  scrollToTopic: PropTypes.func.isRequired,
  activeTopic: PropTypes.string,
};

export default RequestCodesSection;
